<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>External Training Report</h1>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <form (keydown)="onKeyDown($event)">
        <div class="row" *ngIf="saveSuccess">
            <div class="col-24">
                <div class="alert success">
                    <p><em>Thank you!</em></p>
                    <ul>
                        <li>
                            <p>{{saveSuccess}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <label>Start Date</label>
                    <JQDatePicker (elementClicked)="ExternalTrainingSearchCriteriaVM.startDate = $event" [selectedDate]="ExternalTrainingSearchCriteriaVM.startDate">
                    </JQDatePicker>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <label>End Date</label>
                    <JQDatePicker (elementClicked)="ExternalTrainingSearchCriteriaVM.endDate = $event" [selectedDate]="ExternalTrainingSearchCriteriaVM.endDate">
                    </JQDatePicker>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="getExternalTrainingReport()">Search</button>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="exportToExcel()">Export to excel</button>
            </div>
        </div>
    </form>
        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <div class="jqgrid-header-wrap">
                        <jqxGrid [width]="1240" [source]="dataAdapter" [columns]="columns" [autoshowcolumnsmenubutton]="false" [pageable]="false" [sortable]="true" [columnsresize]="true" [selectionmode]="'multiplecellsadvanced'" [editable]="false" [filterable]="true" #gridReference></jqxGrid>
                    </div>
                </div>
            </div>
        </div>
</div>
